"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _authActions = require("../redux/actions/authActions");
var _FullPageSpinner = _interopRequireDefault(require("../components/common/FullPageSpinner/FullPageSpinner"));
var _path = _interopRequireDefault(require("../helpers/path"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function withAuthentication(WrappedComponent) {
  var ModifiedComponent = function ModifiedComponent(props) {
    var isAuthenticated = props.isAuthenticated,
      isAuthenticating = props.isAuthenticating,
      location = props.location,
      pendingAuth = props.pendingAuth,
      redirectFromLogin = props.redirectFromLogin;
    if (pendingAuth || !isAuthenticated && isAuthenticating) {
      return /*#__PURE__*/_react["default"].createElement(_FullPageSpinner["default"], null);
    }
    if (!isAuthenticated) {
      redirectFromLogin(location);
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
        to: (0, _path["default"])('/login')
      });
    }
    return /*#__PURE__*/_react["default"].createElement(WrappedComponent, props);
  };
  var mapStateToProps = function mapStateToProps(state) {
    return {
      /**
       * Token exists in localStorage before redux.
       */
      isAuthenticating: !!localStorage.getItem('token'),
      isAuthenticated: state.auth.isAuthenticated,
      pendingAuth: state.auth.pending
    };
  };
  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      redirectFromLogin: function redirectFromLogin(location) {
        return dispatch((0, _authActions.redirectFromLogin)(location));
      }
    };
  };
  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ModifiedComponent);
}
var _default = exports["default"] = withAuthentication;